let isPdBoxInitialized = false
const pdBox = window.pdBox || {}

function initializePdBox() {
	if (isPdBoxInitialized) return

	const box = new $.pdBox({ isAjax: true })
	const innerBox = new $.pdBox({ isInner: true })

	pdBox.box = box
	pdBox.innerBox = innerBox

	pdBox.multiactionsBasketClose = function () {
		const $target = $('#order').find('> .ajax-wrap')
		const $overlay = $('<div class="ajax-overlay" />')
		const $loader = $('<div class="ajax-loader" />')
		$target.append($overlay, $loader)
		setTimeout(function () {
			window.location.reload()
		}, 500)
	}

	$.nette.ext('pdbox').box = box

	$.nette.ext('pdbox').box.html = function () {
		$content =
			"<div class='pdbox__window'>" +
			"	<div class='pdbox__content'>" +
			"		<h2 class='pdbox__title'></h2>" +
			"		<div class='pdbox__desc'>" +
			"<div id='snippet--pdbox' class='pdbox__snippet'></div>" +
			'		</div>' +
			"		<p class='pdbox__pager'>" +
			"			<a href='#' class='pdbox__page pdbox__page--prev' rel=''><span>" +
			box.langs[box.options.lang]['prev'] +
			'</span></a>' +
			"			<span class='pdbox__pages'></span>" +
			"			<span class='pdbox__pages-summary'><span class='pdbox__active-page'></span>" +
			box.langs[box.options.lang]['of'] +
			"<span class='pdbox__pages-count'></span></span>" +
			"			<a href='#' class='pdbox__page pdbox__page--next' rel=''><span>" +
			box.langs[box.options.lang]['next'] +
			'</span></a>' +
			'		</p>' +
			"		<p class='pdbox__media-box'></p>" +
			"		<div class='pdbox__pager--thumbnails'></div>" +
			box.spinnerHtml +
			"		<a href='#' class='pdbox__close'><span aria-hidden='true'></span>" +
			box.langs[box.options.lang]['close'] +
			'</a>' +
			'	</div>' +
			'</div>'

		return $content
	}

	// Globální pdBox
	window.pdBox = pdBox

	isPdBoxInitialized = true

	return pdBox
}
